import {Component,inject,Optional } from '@angular/core';
import {AbstractControl, FormBuilder, FormGroup, Validators} from '@angular/forms';
import {GraphServiceService } from '../../../../services/graph-service.service';
import { CrmService } from '../../../../services/api/crm.service';
import { MatDialogRef } from '@angular/material/dialog';
import { AlertService } from '../../../../services/notify/alert.service';
import { TranslateService } from '@ngx-translate/core';
import { catchError, EMPTY, filter, from, map, Observable, Subscription, switchMap, tap } from 'rxjs';
import { TFormState } from '../../../../models/forms.model';
import { HelpersService } from '../../../../services/helpers.service';
import { DialogsMTService, IconfirmDialogSettings } from '../../../../services/modal/dialogs-mt.service';
import { Router } from '@angular/router';
import { TaskServiceService } from '../../../../services/task-service.service';
import { TaskOptionsService } from '../../../../services/task-options.service';
import { BoardGroupModel } from '../../../../models/tasktable.model';

@Component({
    selector: 'app-board-mngt-form',
    templateUrl: './board-mngt-form.html',
    styleUrl: './board-mngt-form.scss'
})
export class AppBoardMngtFormComponent {
    private subs = new Subscription
	public mngtBoardForm: FormGroup|undefined = undefined
    public boardGroups:BoardGroupModel[]|undefined = undefined
	public formState:TFormState = 'Default'
	public formMode:'Copy'|'Create' = 'Copy'
    public aliasesTaken:string[]|null = null
	private boardAlias:string = ''
    private dialogRef = inject(MatDialogRef<AppBoardMngtFormComponent>,{optional:true})
	constructor(
        private graphService: GraphServiceService,
		private router: Router,
		private taskService: TaskServiceService,
		private crmService: CrmService,
		private alertService: AlertService,
		private helpersService: HelpersService,
		private translateService: TranslateService,
		private dialogsMTService: DialogsMTService,
        private taskOptionsService: TaskOptionsService,
		private fb: FormBuilder,
	) {}
    ngOnDestroy(): void {
        this.subs.unsubscribe()
    }
	ngOnInit(): void {
		this.boardAlias = this.graphService?.optionBoard?.alias
		this.mngtBoardForm = this.fb.group({
			name:[null, {validators: [Validators.required]}],
			alias:[null, {validators:[Validators.required,this.aliasIsUnique(this.aliasesTaken!)]}],
			icon:[null],
			group_id:[null],
			description:[null],
            need_to_create_statuses:[false]
		})
        this.subs.add(
            this.name?.valueChanges.pipe(filter(res=>res.length<=3)).subscribe(res=>{
                this.alias?.patchValue(this.helpersService.generateDashboardAlias(res))
            })
        )
	}
    createBoard() {
        this.crmService.createDashboard(this.mngtBoardForm?.value)
        .pipe(catchError(err=>this.errorHandler(err)))
        .subscribe( res => {
            this.formState = 'Default';
            this.dialogRef?.close({board:res.task_board})
            this.alertService.setAlert(this.translateService.instant('ALERTS.SUCCESS'), 'nd_color');
            //this.eminOnCreateDashboard.emit(res.task_board);
        });
    }
    copyBoard() {
		this.formState = 'Submitting'
        let dialogSettings:IconfirmDialogSettings = {
            actionHeader: 'CONFIRM.HEADERS.ATTENTION',
            actionBody: 'CONFIRM.TEXT.OPEN_BP'
        }
		this.crmService.copyTaskBoard(this.boardAlias, this.mngtBoardForm?.value)
		.pipe(
			switchMap(data=>this.dialogsMTService.confirmDialog(dialogSettings).pipe(
                catchError(error=>this.errorHandler(error,false)),
                map(res=>{
                    return {res:res,data:data}
                }))),
            tap(res => res.res?.isConfirmed? this.taskService.setBoard(res.data.board.alias, true) : null),
            tap(res => res.res?.isConfirmed? this.router.navigate(['account', 'tasks', 'all', res.data.board.alias]) : null),
			catchError(error=>this.errorHandler(error)))
		.subscribe(() => {
			this.formState = 'Default';
			this.dialogRef?.close()
			this.alertService.setAlert(this.translateService.instant('ALERTS.SUCCESS'), 'nd_color');
            this.taskOptionsService.onLoadBoards(true);
		})
    }
    aliasIsUnique(aliasesTaken:string[]) {
        return (control:AbstractControl) => {
            if (this.aliasesTaken?.includes(control?.value)) {
                return {aliasTaken:true}
            } else {
                return null
            }
        }
    }
    errorHandler(error:{message:string},showErrMsg = true):Observable<never> {
		this.formState = 'Default';
		showErrMsg? this.alertService.setAlert(error.message, 'blue') : null;
		return EMPTY
	}

	get name()  {return this.mngtBoardForm?.get('name')}
	get alias()  {return this.mngtBoardForm?.get('alias')}
	get icon()  {return this.mngtBoardForm?.get('icon')}
	get description()  {return this.mngtBoardForm?.get('description')}
}